import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function CloseSection() {
  return <section className="w-full bg-navy py-24 px-4 pb-32" data-id="element-25" data-mp="3dhl4e4q6q7dt">
      <div className="max-w-3xl mx-auto text-center" data-id="element-26" data-mp="2zjed57fqr5n4">
        <h2 className="text-3xl md:text-4xl font-headline font-bold text-white uppercase mb-12" data-id="element-27" data-mp="2zkxvr4ovdss2">
          Tienes Dos Caminos
        </h2>

        <p className="text-xl text-gray-300 mb-12" data-id="element-28" data-mp="2psjra46eq827">Tienes dos caminos:</p>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-29" data-mp="2ujidfke2u0dd">
          <div className="bg-navy-light p-6 rounded-xl border border-white/5 opacity-70 hover:opacity-100 transition-opacity" data-id="element-30" data-mp="2ul38db4azlbr">
            <div className="text-danger font-bold text-lg mb-2" data-id="element-31" data-mp="2gqaipjup8org">Camino 1</div>
            <p className="text-gray-400 text-sm" data-id="element-32" data-mp="2ktypw1ff5ic6">
              Seguir esperando a que la "suerte" ayude a tu hijo mientras los
              años críticos (13, 14, 15) pasan volando.
            </p>
          </div>

          <div className="bg-navy-light p-6 rounded-xl border border-gold/30 shadow-[0_0_20px_rgba(245,166,35,0.1)]" data-id="element-33" data-mp="2buv7z0rzn8z9">
            <div className="text-gold font-bold text-lg mb-2" data-id="element-34" data-mp="3oy6gm7asssck">Camino 2</div>
            <p className="text-white text-sm" data-id="element-35" data-mp="3p095go07sffp">
              Tomar el mapa de los que ya conocen el sistema y darle a tu hijo
              la oportunidad que su talento merece.
            </p>
          </div>
        </div>

        <button onClick={() => {
        trackInitiateCheckout();
        window.open('https://ebookdigital.digital//cart/47440735863033:1', '_blank');
      }} className="w-full md:w-auto bg-gold hover:bg-gold-light text-navy-light font-headline font-bold text-xl px-12 py-5 rounded-lg shadow-[0_0_30px_rgba(245,166,35,0.4)] transition-all transform hover:scale-105 flex items-center justify-center gap-2 uppercase mx-auto" data-id="element-36" data-mp="3a8qrswutuwzi">
          ¡Quiero el acceso inmediato!
          <ArrowRight className="w-6 h-6" data-id="element-37" data-mp="2miwhalxzdkif" />
        </button>

        <p className="mt-8 text-muted text-sm" data-id="element-38" data-mp="qgt57myx6cvx">
          © {new Date().getFullYear()} Método Beca Pro. Todos los derechos
          reservados.
        </p>
      </div>
    </section>;
}